import { Component } from 'react';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';
import ComponentWithAnalytics from '@atlassian/jira-analytics-web-react/src/utils/component-with-analytics.tsx';
import type { LegacyBreadcrumbItem, LegacyBreadcrumbId } from '../types.tsx';
import registerBridge from './service/index.tsx';
import type { Props as BaseProps, AnalyticsEventProps } from './types.tsx';

type Props = BaseProps & AnalyticsEventProps;

// eslint-disable-next-line jira/react/no-class-components
class LegacyApiBridge extends Component<Props> {
	componentDidMount() {
		const { onInsertItem, onRemoveItem, onSetRenderTarget, onBreadCrumbsUpdate } = this;

		registerBridge({
			insertItem: onInsertItem,
			removeItem: onRemoveItem,
			render: onSetRenderTarget,
			onBreadCrumbsUpdate,
		});
	}

	/* eslint-disable jira/react-no-unneeded-arrow-function-properties */
	onInsertItem = (item: LegacyBreadcrumbItem) => {
		const { onInsertItem, onInsertItemFired } = this.props;
		onInsertItemFired();

		onInsertItem(item);
	};

	onRemoveItem = (itemId: LegacyBreadcrumbId) => {
		const { onRemoveItem, onRemoveItemFired } = this.props;
		onRemoveItemFired();

		onRemoveItem(itemId);
	};

	onSetRenderTarget = (element: HTMLElement) => {
		const { onSetRenderTarget, onSetRenderTargetFired } = this.props;
		onSetRenderTargetFired();

		onSetRenderTarget(element);
	};

	onBreadCrumbsUpdate = () => {
		const { onOnBreadCrumbsUpdateFired } = this.props;
		onOnBreadCrumbsUpdateFired();

		return Observable.empty<never>();
	};
	/* eslint-enable jira/react-no-unneeded-arrow-function-properties */

	render() {
		return null;
	}
}

export default ComponentWithAnalytics('legacyApiBridge', {
	onInsertItemFired: 'apiMethodCalled',
	onRemoveItemFired: 'apiMethodCalled',
	onSetRenderTargetFired: 'apiMethodCalled',
	onOnBreadCrumbsUpdateFired: 'apiMethodCalled',
})(LegacyApiBridge);
